import { CheckBox, CheckBoxProps } from 'lego-on-react';
import * as React from 'react';

export interface CheckboxDecoratorCheckedItem {
    checked: boolean;
    item?: object;
}

type CheckboxDecoratorProps = {
    disabled?: boolean;
    item?: {};
    onChecked?: (e: React.KeyboardEvent<HTMLElement>, data: CheckboxDecoratorCheckedItem) => void;
} & CheckBoxProps;

export class CheckboxDecorator extends React.PureComponent<CheckboxDecoratorProps> {
    render() {
        return (
            <CheckBox {...this.props} onChange={this.onChecked}>
                {this.props.children}
            </CheckBox>
        );
    }

    private onChecked = (e: React.KeyboardEvent<HTMLElement>) => {
        const { onChecked, checked } = this.props;

        if (onChecked === undefined) {
            return;
        }

        onChecked(e, {
            checked: !checked,
            item: this.props.item
        });
    };
}
